<template>
  <a-form-model
      ref="targetForm"
      :model="form"
      :rules="rules"
      :label-col="{span: 12}"
      :wrapper-col="{span: 12}"
  >
    <a-alert message="温馨提示：请注意您填写的信息仅适用于签证申请，请如实提供真实信息。" banner closable/>
    <a-card title="申请资料">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="大使馆" prop="visaLocation">
            <a-select v-model="form.visaLocation" placeholder="请选择">
              <a-select-option value="Royal Thai Embassy, Beijing">北京</a-select-option>
              <a-select-option value="Royal Thai Consulate-General, Shanghai">上海</a-select-option>
              <a-select-option value="Royal Thai Consulate-General, Guangzhou">广州</a-select-option>
              <a-select-option value="Royal Thai Consulate-General, Chengdu">成都</a-select-option>
              <a-select-option value="Royal Thai Consulate-General, Nanning">南宁</a-select-option>
              <a-select-option value="Royal Thai Consulate-General, Kunming">昆明</a-select-option>
              <a-select-option value="Royal Thai Consulate-General, Xian">西安</a-select-option>
              <a-select-option value="Royal Thai Consulate-General, Xiamen">厦门</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="签证类型" prop="visaLocation">
            <a-select v-model="form.visaType" placeholder="请选择">
              <a-select-option value="Tourism / Leisure activities">旅游</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="邮箱" prop="email">
            <a-input placeholder="例如 xxx@gmail.com" v-model="form.email"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="手机号" prop="phoneNumber">
            <a-input addon-before="+86" v-model="form.phoneNumber" placeholder="例如 13900000000"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="婚姻状况" prop="maritalStatus">
            <a-select v-model="form.maritalStatus" placeholder="请选择">
              <a-select-option value="SINGLE">单身</a-select-option>
              <a-select-option value="MARRIED">已婚</a-select-option>
              <a-select-option value="WIDOWED">丧偶</a-select-option>
              <a-select-option value="DIVORCED">离异</a-select-option>
              <a-select-option value="SEPARATE">分离</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址" prop="homeAddressForStreet">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.homeAddressForStreet"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址城市" prop="homeAddressForCity">
            <a-input placeholder="例如 广州" v-model="form.homeAddressForCity"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="工作状态" prop="workType">
            <a-select v-model="form.workType" placeholder="请选择">
              <a-select-option value="Business owner">企业主</a-select-option>
              <a-select-option value="Employee">受雇者</a-select-option>
              <a-select-option value="Freelance">自由职业</a-select-option>
              <a-select-option value="Government Official">政府官员</a-select-option>
              <a-select-option value="Retired">已退休</a-select-option>
              <a-select-option value="Student">学生</a-select-option>
              <a-select-option value="Unemployed">失业的</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="机构名称" prop="companyName">
            <a-input v-model="form.companyName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="收入" prop="income">
            <a-select v-model="form.income" placeholder="请选择">
              <a-select-option value="Under 20,000 US$">Under 20,000 US$</a-select-option>
              <a-select-option value="40,001 - 60,000 US$">40,001 - 60,000 US$</a-select-option>
              <a-select-option value="60,001 - 80,000 US$">60,001 - 80,000 US$</a-select-option>
              <a-select-option value="80,001 and over">80,001 and over</a-select-option>
              <a-select-option value="No income">No income</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="出境资料" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="行程安排" prop="intendDate">
            <a-range-picker style="width: 100%" v-model="form.intendDate" value-format="YYYY-MM-DD"
                            :placeholder="['入境日期', '出境日期']" :inputReadOnly="true" :disabled-date="beforeNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="航班号" prop="flightNo">
            <a-input v-model="form.flightNo" placeholder="例如 CA12**"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾到过泰国" prop="everVisited">
            <a-radio-group v-model="form.everVisited">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="曾申请泰国签证" prop="everApplicant">
            <a-radio-group v-model="form.everApplicant">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="旅行团一员" prop="partTourGroup">
            <a-radio-group v-model="form.partTourGroup">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="住处类型" prop="accommodationType">
            <a-select v-model="form.accommodationType" placeholder="请选择">
              <a-select-option value="1">酒店</a-select-option>
              <a-select-option value="2">旅社</a-select-option>
              <a-select-option value="5">小旅馆</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="住处名称" prop="accommodationName">
            <a-input v-model="form.accommodationName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="住处城市" prop="accommodationCity">
            <a-select placeholder="请选择" v-model="form.accommodationCity">
              <a-select-option v-for="item in cityList" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="上传资料" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="证件照">
            <a-upload
                v-model="form.photographImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="handlePhotographChange">
              <img v-if="form.photographImgUrl" :src="form.photographImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="photographImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="Declaration 文件">
            <a-upload
                v-model="form.declarationImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="declarationImgChange">
              <img v-if="form.declarationImgUrl" :src="form.declarationImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="declarationImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="往返机票单">
            <a-upload
                v-model="form.travelBookImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="travelBookImgChange">
              <img v-if="form.travelBookImgUrl" :src="form.travelBookImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="travelBookImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="住宿确认信">
            <a-upload
                v-model="form.accommodationImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="accommodationImgChange">
              <img v-if="form.accommodationImgUrl" :src="form.accommodationImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="accommodationImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="存款证明">
            <a-upload
                v-model="form.financialImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="financialImgChange">
              <img v-if="form.financialImgUrl" :src="form.financialImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="financialImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="国内住址证明">
            <a-upload
                v-model="form.residenceImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="residenceImgChange">
              <img v-if="form.residenceImgUrl" :src="form.residenceImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="residenceImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="户籍本">
            <a-upload
                v-model="form.householdImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="householdImgChange">
              <img v-if="form.householdImgUrl" :src="form.householdImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="householdImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="无犯罪证明">
            <a-upload
                v-model="form.criminalImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="criminalImgChange">
              <img v-if="form.criminalImgUrl" :src="form.criminalImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="criminalImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照出入境记录">
            <a-upload
                v-model="form.passportTripImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="passportTripImgChange">
              <img v-if="form.passportTripImgUrl" :src="form.passportTripImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="passportTripImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="手持护照">
            <a-upload
                v-model="form.passportHandleImgUrl"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="url.recognition"
                :data="{bucket: 'esvisa', bizPath: 'avatar'}"
                :headers="this.headersWithoutJson"
                :before-upload="beforeUpload"
                @change="passportHandleImgChange">
              <img v-if="form.passportHandleImgUrl" :src="form.passportHandleImgUrl" width="100px"/>
              <div v-else>
                <a-icon :type="passportHandleImg.loading ? 'loading' : 'plus'"/>
                <div class="ant-upload-text">
                  上传
                </div>
              </div>
            </a-upload>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
  </a-form-model>
</template>

<script>

import moment from 'moment';
import 'moment/locale/zh-cn';
import {HttpMixins} from "@/mixins/http-mixins";

const pattern = {
  english: /^[A-Za-z]+( [A-Za-z]+)*$/,
  nationalIdentification: /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)|(^([A-Z]|[0-9]){5,17}$)$/,
  zipCode: /^([0-9]\d{4,5})$/,
  cellphone: /^(1[345789]\d{9})$/,
  phone: /^(\d{11,12})$/,
  mail: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  passportNumber: /^([A-Z]|[0-9]){5,17}$/,
  numberOrEnglish: /^([A-Za-z0-9 ]*)$/,
  numberOrChinaOrEnglish: /^([\u4E00-\u9FA5\w\- ]+)$/,
  number: /^([0-9]*)$/,
}


export default {
  name: "DetailCreateTable",
  mixins: [HttpMixins],
  data() {
    return {
      moment,
      model: {},
      form: {},
      photographImg: {
        loading: false,
        name: 'photographImgUrl',
      },
      declarationImg: {
        loading: false,
        name: 'declarationImgUrl',
      },
      travelBookImg: {
        loading: false,
        name: 'travelBookImgUrl',
      },
      accommodationImg: {
        loading: false,
        name: 'accommodationImgUrl',
      },
      financialImg: {
        loading: false,
        name: 'financialImgUrl',
      },
      residenceImg: {
        loading: false,
        name: 'residenceImgUrl',
      },
      passportTripImg: {
        loading: false,
        name: 'passportTripImgUrl',
      },
      criminalImg: {
        loading: false,
        name: 'criminalImgUrl',
      },
      householdImg: {
        loading: false,
        name: 'householdImgUrl',
      },
      passportHandleImg: {
        loading: false,
        name: 'passportHandleImgUrl',
      },
      cityList: [
        {value: 'Amnat Charoen', name: 'Amnat Charoen'},
        {value: 'Ang Thong', name: 'Ang Thong'},
        {value: 'Bangkok', name: 'Bangkok'},
        {value: 'Bungkan', name: 'Bungkan'},
        {value: 'Buri Ram', name: 'Buri Ram'},
        {value: 'Chachoengsao', name: 'Chachoengsao'},
        {value: 'Chai Nat', name: 'Chai Nat'},
        {value: 'Chaiyaphum', name: 'Chaiyaphum'},
        {value: 'Chanthaburi', name: 'Chanthaburi'},
        {value: 'Chiang Mai', name: 'Chiang Mai'},
        {value: 'Chiang Rai', name: 'Chiang Rai'},
        {value: 'Chon Buri', name: 'Chon Buri'},
        {value: 'Chumphon', name: 'Chumphon'},
        {value: 'Kalasin', name: 'Kalasin'},
        {value: 'Kamphaeng Phet', name: 'Kamphaeng Phet'},
        {value: 'Kanchanaburi', name: 'Kanchanaburi'},
        {value: 'Khon Kaen', name: 'Khon Kaen'},
        {value: 'Krabi', name: 'Krabi'},
        {value: 'Lampang', name: 'Lampang'},
        {value: 'Lamphun', name: 'Lamphun'},
        {value: 'Loei', name: 'Loei'},
        {value: 'Lopburi', name: 'Lopburi'},
        {value: 'Mae Hong Son', name: 'Mae Hong Son'},
        {value: 'Maha Sarakham', name: 'Maha Sarakham'},
        {value: 'Mukdahan', name: 'Mukdahan'},
        {value: 'Nakhon Nayok', name: 'Nakhon Nayok'},
        {value: 'Nakhon Pathom', name: 'Nakhon Pathom'},
        {value: 'Nakhon Phanom', name: 'Nakhon Phanom'},
        {value: 'Nakhon Ratchasima', name: 'Nakhon Ratchasima'},
        {value: 'Nakhon Sawan', name: 'Nakhon Sawan'},
        {value: 'Nakhon Si Thammarat', name: 'Nakhon Si Thammarat'},
        {value: 'Nan', name: 'Nan'},
        {value: 'Narathiwat', name: 'Narathiwat'},
        {value: 'Nong Bua Lam Phu', name: 'Nong Bua Lam Phu'},
        {value: 'Nong Khai', name: 'Nong Khai'},
        {value: 'Nonthaburi', name: 'Nonthaburi'},
        {value: 'Pathum Thani', name: 'Pathum Thani'},
        {value: 'Pattani', name: 'Pattani'},
        {value: 'Phangnga', name: 'Phangnga'},
        {value: 'Phatthalung', name: 'Phatthalung'},
        {value: 'Phayao', name: 'Phayao'},
        {value: 'Phetchabun', name: 'Phetchabun'},
        {value: 'Phetchaburi', name: 'Phetchaburi'},
        {value: 'Phichit', name: 'Phichit'},
        {value: 'Phitsanulok', name: 'Phitsanulok'},
        {value: 'Phra Nakhon Si Ayutthaya', name: 'Phra Nakhon Si Ayutthaya'},
        {value: 'Phrae', name: 'Phrae'},
        {value: 'Phuket', name: 'Phuket'},
        {value: 'Prachin Buri', name: 'Prachin Buri'},
        {value: 'Prachuap Khiri Khan', name: 'Prachuap Khiri Khan'},
        {value: 'Ranong', name: 'Ranong'},
        {value: 'Ratchaburi', name: 'Ratchaburi'},
        {value: 'Rayong', name: 'Rayong'},
        {value: 'Roi Et', name: 'Roi Et'},
        {value: 'Sa Kaeo', name: 'Sa Kaeo'},
        {value: 'Sakon Nakhon', name: 'Sakon Nakhon'},
        {value: 'Samut Prakan', name: 'Samut Prakan'},
        {value: 'Samut Sakhon', name: 'Samut Sakhon'},
        {value: 'Samut Songkhram', name: 'Samut Songkhram'},
        {value: 'Saraburi', name: 'Saraburi'},
        {value: 'Satun', name: 'Satun'},
        {value: 'Si Sa Ket', name: 'Si Sa Ket'},
        {value: 'Sing Buri', name: 'Sing Buri'},
        {value: 'Songkhla', name: 'Songkhla'},
        {value: 'Sukhothai', name: 'Sukhothai'},
        {value: 'Suphan Buri', name: 'Suphan Buri'},
        {value: 'Surat Thani', name: 'Surat Thani'},
        {value: 'Surin', name: 'Surin'},
        {value: 'Tak', name: 'Tak'},
        {value: 'Trang', name: 'Trang'},
        {value: 'Trat', name: 'Trat'},
        {value: 'Ubon Ratchathani', name: 'Ubon Ratchathani'},
        {value: 'Udon Thani', name: 'Udon Thani'},
        {value: 'Uthai Thani', name: 'Uthai Thani'},
        {value: 'Uttaradit', name: 'Uttaradit'},
        {value: 'Yala', name: 'Yala'},
        {value: 'Yasothon', name: 'Yasothon'}
      ],
      rules: {
        visaLocation: [{required: true, message: '必填!'}],
        visaType: [{required: true, message: '必填!'}],
        email: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],
        phoneNumber: [{required: true, pattern: pattern.cellphone, message: '输入有误,请检查!'}],
        maritalStatus: [{required: true, message: '输入有误,请检查!'}],
        homeAddressForStreet: [{required: true, message: '输入有误,请检查!'}],
        homeAddressForCity: [{required: true, message: '输入有误,请检查!'}],
        workType: [{required: true, message: '输入有误,请检查!'}],
        companyName: [{required: true, message: '输入有误,请检查!'}],
        income: [{required: true, message: '输入有误,请检查!'}],
        intendDate: [{required: true, message: '输入有误,请检查!'}],
        flightNo: [{required: true, message: '输入有误,请检查!'}],
        everVisited: [{required: true, message: '输入有误,请检查!'}],
        everApplicant: [{required: true, message: '输入有误,请检查!'}],
        partTourGroup: [{required: true, message: '输入有误,请检查!'}],
        accommodationType: [{required: true, message: '输入有误,请检查!'}],
        accommodationName: [{required: true, message: '输入有误,请检查!'}],
        photographImgUrl: [{required: true, message: '输入有误,请检查!'}],
        declarationImgUrl: [{required: true, message: '输入有误,请检查!'}],
        travelBookImgUrl: [{required: true, message: '输入有误,请检查!'}],
        accommodationImgUrl: [{required: true, message: '输入有误,请检查!'}],
        financialImgUrl: [{required: true, message: '输入有误,请检查!'}],
        residenceImgUrl: [{required: true, message: '输入有误,请检查!'}],
        criminalImgUrl: [{required: true, message: '输入有误,请检查!'}],
        passportTripImgUrl: [{required: true, message: '输入有误,请检查!'}],
        householdImgUrl: [{required: true, message: '输入有误,请检查!'}],
        passportHandleImgUrl: [{required: true, message: '输入有误,请检查!'}]
      },
      url: {
        complement: window._CONFIG['domainURL'] + "/thaDs/complement",
        draftSave: window._CONFIG['domainURL'] + "/power/thaDs/draftSave",
        recognition: window._CONFIG['domainURL'] + "/power/recognition",
      }
    }
  },
  methods: {
    beforeNow(current) {
      return current && current < moment().startOf('day');
    },
    afterNow(current) {
      return current && current > moment().startOf('day');
    },
    handlePhotographChange(info) {
      this.handleChange(info, this.photographImg);
    },
    declarationImgChange(info) {
      this.handleChange(info, this.declarationImg);
    },
    travelBookImgChange(info) {
      this.handleChange(info, this.travelBookImg);
    },
    accommodationImgChange(info) {
      this.handleChange(info, this.accommodationImg);
    },
    financialImgChange(info) {
      this.handleChange(info, this.financialImg);
    },
    residenceImgChange(info) {
      this.handleChange(info, this.residenceImg);

    },
    criminalImgChange(info) {
      this.handleChange(info, this.criminalImg);
    },
    passportTripImgChange(info) {
      this.handleChange(info, this.passportTripImg);
    },
    householdImgChange(info) {
      this.handleChange(info, this.householdImg);
    },
    passportHandleImgChange(info) {
      this.handleChange(info, this.passportHandleImg);
    },
    handleChange(info, data) {
      if (info.file.status === 'uploading') {
        data.loading = true;
        this.$set(this.form, [data.name], '');
      }
      if (info.file.status === 'done') {
        data.loading = false;
        let response = info.file.response;
        if (response.code === 200) {
          this.$set(this.form, [data.name], response.data.url);
        }
      }
      if (info.file.status === 'error') {
        data.loading = false;
      }
    },
    beforeUpload(file) {
      let that = this;
      const isJpg = file.type === 'image/jpeg';
      if (!isJpg) {
        that.$message.error('只支持上传 JPG 格式!');
        return false;
      }
      const isLt200kb = file.size / 1024 < 800;
      if (!isLt200kb) {
        that.$message.error('证件文件大小必须小于 800KB!');
        return false;
      }
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width < 2400 && img.height < 2400;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
          () => {
            return file;
          },
          () => {
            that.$message.error('上传图片分辨率要小于2400*2400px!');
            return Promise.reject();
          });
      return isSize;
    },
    handleDraft() {
      const that = this;
      that.model.content = JSON.stringify(that.form);
      that.$axios.put(that.url.draftSave, that.model, {headers: that.headers})
          .then((res) => {
            let response = res.data;
            if (response.code === 200) {
              that.$message.success(response.msg);
              that.$emit('completeDraft');
            } else {
              that.$message.error(response.msg);
            }
          })
          .catch((error) => {
            that.catchError(error);
          });
    },
    init(data) {
      this.$refs.targetForm.clearValidate();
      this.model = Object.assign({}, data);
      this.form = {};
      if (this.model.content) {
        this.form = JSON.parse(this.model.content);
      }
      if (!this.form.visaType) {
        this.form.visaType = "Tourism / Leisure activities";
      }
      if (!this.form.everVisited) {
        this.form.everVisited = "No";
      }
      if (!this.form.everApplicant) {
        this.form.everApplicant = "No";
      }
      if (!this.form.partTourGroup) {
        this.form.partTourGroup = "Yes";
      }
    },
    handleValid() {
      this.$refs.targetForm.validate((valid) => {
        if (valid) {
          this.$message.success("验证通过")
          return;
        }
        this.$message.warning("验证不通过")
      })
    },
    handleSubmit() {
      const that = this;
      this.$refs.targetForm.validate((valid) => {
        if (valid) {
          that.$emit('before');
          that.model.content = JSON.stringify(that.form);
          that.$axios.put(that.url.complement, that.model, {headers: that.headers})
              .then((res) => {
                let response = res.data;
                if (response.code === 200) {
                  that.$emit('complete');
                } else {
                  that.$message.error(response.msg);
                }
              })
              .catch((error) => {
                that.catchError(error);
              })
              .finally(() => {
                that.$emit('finally');
              });
        } else {
          that.$message.warning("验证不通过")
        }
      })
    }
  }
}
</script>

<style scoped>

.dynamic-add-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #87d068;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-add-button:hover {
  color: #26cc2a;
}

.dynamic-add-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

</style>
